<template lang="pug">
  v-container.pa-0(fluid)
    v-card
      v-card-title {{ title }}
      v-card-text.title
        v-container.pa-0
          v-tabs
            v-tab {{ $t('bankTransactionPage.propertiesTabLabel') }}
            v-tab {{ $t('bankTransactionPage.amountToWalletTabLabel') }}

            v-tab-item
              BankTransactionPropertiesTab( v-if="resolveTransactionData" :transactionDetail="resolveTransactionData" )
            v-tab-item
              BankTransactionAmountToWalletTab( v-if="resolveTransactionData" :transactionDetail="resolveTransactionData")

      v-divider
      v-card-actions
        v-spacer
        v-btn(color="primary"  @click="onSubmitButtonClick")  {{ $t('bankTransactionPage.finishButtonLabel') }}
        v-btn(v-if="isNextButton" color="primary"  @click="onNextButtonClick")  {{ $t('bankTransactionPage.next') }}

</template>

<script lang="ts">
import Vue from 'vue'
import moment from "moment/moment";
import {Component, Prop,} from 'vue-property-decorator'
import BankTransaction from "@/model/BankTransaction/BankTransaction";
import BankTransactionAmountToWalletTab from "@/components/user/BankTransactionAmountToWalletTab.vue";
import BankTransactionPropertiesTab from "@/components/user/BankTransactionPropertiesTab.vue";


@Component({
  components: {
    BankTransactionPropertiesTab,
    BankTransactionAmountToWalletTab
  },
})
export default class ControlResolveDialog extends Vue {
  @Prop({ type: Object, required: false }) readonly resolveTransactionData!: BankTransaction
  @Prop({ type: Boolean, required: false }) readonly isNextButton!: boolean
  @Prop({ type: String, required: false }) readonly title!: string
  private amount: number | null = null
  private invoices: number | null = null
  private amountToWallet: number | null = null
  private amountPayed: number | null = null


  get getTitle (): string {
    if(this.resolveTransactionData.boarder && this.resolveTransactionData.boarder.person && this.resolveTransactionData.boarder.person.firstName && this.resolveTransactionData.boarder.person.familyName) {
      return `${this.resolveTransactionData.boarder.person.firstName} ${this.resolveTransactionData.boarder.person.familyName}`
    } else {
      return ''
    }
  }

  getFormattedDate (item: string): string {
    return moment(item).format('D.M.YYYY')
  }

  getCredit (amountToWallet: number) {
    if(amountToWallet){
      return amountToWallet / 100
    }
  }

  getInvoices (invoices: number) {
    if(invoices){
      return (invoices / 100).toFixed(2)
    } else {
      return 0
    }
  }

  onSubmitButtonClick () {
    this.$emit('complete')
  }

  onNextButtonClick () {
    this.$emit('next')
  }

  mounted() {
  }
}

</script>

<style lang="stylus" scoped>

.style
  color: green

</style>
